import { Component, Input } from '@angular/core';
import {
  AnnotationColorLegendGroup,
  AnnotationColorLegendItem,
} from './annotation-color-legend.model';

@Component({
  selector: 'app-annotation-color-legend',
  templateUrl: './annotation-color-legend.component.html',
  styleUrl: './annotation-color-legend.component.css',
  standalone: false,
})
export class AnnotationColorLegendComponent {
  @Input() items: AnnotationColorLegendItem[] = [];

  private readonly groupLabels: Record<AnnotationColorLegendGroup, string> = {
    x: 'X Axis',
    y: 'Y Axis',
    other: 'Other',
  };

  private readonly groupOrder: AnnotationColorLegendGroup[] = ['x', 'y', 'other'];

  groupedItems(): { group: AnnotationColorLegendGroup; title: string; items: AnnotationColorLegendItem[] }[] {
    return this.groupOrder
      .map((group) => ({
        group,
        title: this.groupLabels[group],
        items: this.items.filter((item) => item.group === group),
      }))
      .filter((section) => section.items.length > 0);
  }

  displayLabel(item: AnnotationColorLegendItem): string {
    return item.detail ? `${item.label} - ${item.detail}` : item.label;
  }
}
